import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Shift } from "@app/models/rest/roster/shift";
import { ShiftRestService } from "@app/services/hal/roster/shift-rest-service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class ShiftStore extends RealTimeDataStore<Shift> {
  constructor() {
    const shiftRestService = inject(ShiftRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(shiftRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Shift");
  }
}
